import './LogoDws.scss';
import React, { FC } from 'react';
import classNames from 'classnames';
import LogoSrc from '@/assets/images/logo-dws.svg?url';

type LogoProps = {
    className?: string;
    fontSize?: number;
};

const LogoDws: FC<LogoProps> = ({ className, fontSize }) => {
    const logoStyles = {};
    if (fontSize) {
        logoStyles['fontSize'] = fontSize;
    }

    return (
        <figure className={classNames('LogoDws', className)} style={logoStyles}>
            <a
                href="https://www.deutschewildtierstiftung.de/"
                target="_blank"
                className="LogoDws_img"
                rel="noreferrer"
            >
                <img src={LogoSrc} alt="Deutsche Wildtier Stiftung" />
            </a>
            <figcaption className="LogoDws_text">
                <a
                    href="https://www.deutschewildtierstiftung.de/"
                    target="_blank"
                    className="LogoDws_textLink"
                    rel="noreferrer"
                >
                    Mit Unterstützung der <br /> Deutschen Wildtier Stiftung
                </a>
            </figcaption>
        </figure>
    );
};

export default LogoDws;
